import React, { useState } from 'react';
import type { StorySpec } from '../../../../../../shared/types/epics';

// FORGE-181: collapsible per-story spec (PDR) — the planner's full Description /
// Acceptance Criteria / Non-Goals / Impl notes. Rendered as preformatted
// markdown (whitespace-preserving, no HTML injection). Omitted entirely when no
// spec is stored for the story (pre-feature epic, or a synthetic/named row).
export const StorySpecPanel: React.FC<{ spec?: StorySpec }> = ({ spec }) => {
  const [open, setOpen] = useState(false);
  if (!spec || !spec.body.trim()) return null;
  return (
    <div className="border-t border-slate-100">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        data-testid={`story-spec-toggle-${spec.idx}`}
        className="w-full flex items-center justify-between px-4 py-2 text-xs font-semibold text-slate-600 hover:bg-slate-50 transition-colors"
      >
        <span className="flex items-center gap-2">
          <span className="text-slate-400">{open ? '▾' : '▸'}</span>
          Spec &amp; acceptance criteria
          {spec.scope.length > 0 && (
            <span className="font-normal text-slate-400">· {spec.scope.join(', ')}</span>
          )}
        </span>
        <span className="font-normal text-slate-400">
          {spec.targetRepo ? <span className="font-mono">{spec.targetRepo}</span> : null}
        </span>
      </button>
      {open && (
        <div className="px-4 pb-3" data-testid={`story-spec-body-${spec.idx}`}>
          <pre className="whitespace-pre-wrap break-words text-xs leading-relaxed text-slate-700 bg-slate-50 border border-slate-200 rounded-md p-3 font-sans">
            {spec.body.trim()}
          </pre>
        </div>
      )}
    </div>
  );
};
